import { workSheetConstants } from '../../_constants';

const initialState = { getCommentListLoading: true, data: '', error: false };

export function getCommentListReducer(state = initialState, action) {
    switch (action.type) {
        case workSheetConstants.REQUEST_GET_COMMENT_LIST:
            return {
                getCommentListLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_GET_COMMENT_LIST:
            return {
                getCommentListLoading: false,
                data: action.getCommentList,
                error: false
            };
        case workSheetConstants.GET_COMMENT_LIST_ERROR:
            return {
                getCommentListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getCommentList.reducer.js